import React from "react";

import Select from "react-dropdown-select";

const DropDown = ({ options, onChange }) => {
  return (
    <div>
      <Select options={options} onChange={onChange} />
    </div>
  );
};

export default DropDown;
